import React from "react";
import { Input } from "@/components/ui/input";
import { Slider } from "@/components/ui/slider";

// One-click creature archetypes the 3D engine builds for enemies / bosses.
export const CREATURE_KINDS_UI = [
  ["", "Auto", "✨"],
  ["monster", "Monster", "👹"],
  ["beast", "Beast", "🐺"],
  ["ghost", "Ghost", "👻"],
  ["flyer", "Flyer", "🦇"],
  ["slime", "Slime", "🟢"],
  ["robot", "Robot", "🤖"],
  ["knight", "Knight", "🛡️"],
  ["alien", "Alien", "👽"],
];

export const SettingRow = ({ k, v }) => (
  <div className="flex items-center justify-between text-sm py-1.5 px-3 rounded-lg bg-[hsl(var(--secondary))]/40">
    <span className="text-[hsl(var(--muted-foreground))]">{k}</span><span className="font-semibold">{v}</span>
  </div>
);

export const PlanLine = ({ k, v }) => (
  <div><span className="font-semibold text-[hsl(var(--muted-foreground))]">{k}: </span>{v}</div>
);

export const SliderRow = ({ label, value, min, max, step, onCommit }) => (
  <div>
    <div className="flex justify-between text-xs mb-1"><span className="text-[hsl(var(--muted-foreground))]">{label}</span><span className="font-bold">{step < 1 ? Number(value).toFixed(2).replace(/\.?0+$/, "") : Math.round(value)}</span></div>
    <Slider defaultValue={[value]} min={min} max={max} step={step} onValueCommit={(v) => onCommit(v[0])} data-testid={`slider-${label.replace(/\s+/g, "-").toLowerCase()}`} />
  </div>
);

export const EmojiInput = ({ label, value, onChange }) => (
  <div><div className="text-[10px] uppercase tracking-wide text-[hsl(var(--muted-foreground))] mb-1">{label}</div>
    <Input value={value} onChange={(e) => onChange(e.target.value.slice(0, 4))} className="h-9 text-center text-lg" /></div>
);

export const ColorInput = ({ label, value, onChange }) => (
  <div><div className="text-[10px] uppercase tracking-wide text-[hsl(var(--muted-foreground))] mb-1">{label}</div>
    <input type="color" value={value} onChange={(e) => onChange(e.target.value)} className="w-full h-9 rounded-lg bg-transparent cursor-pointer border border-[hsl(var(--border))]" /></div>
);

// Chips to one-click set an enemy/boss 3D creature archetype ("" = Auto, infer from emoji).
export const KindChips = ({ label, value, onPick }) => (
  <div>
    <div className="text-[10px] uppercase tracking-wide text-[hsl(var(--muted-foreground))] mb-1">{label}</div>
    <div className="flex flex-wrap gap-1" data-testid={`kind-chips-${label.toLowerCase()}`}>
      {CREATURE_KINDS_UI.map(([val, name, emo]) => {
        const active = (value || "") === val;
        return (
          <button key={val || "auto"} type="button" onClick={() => onPick(val || null)}
            data-testid={`kind-${label.toLowerCase()}-${val || "auto"}`}
            className={`px-2 py-1 rounded-full border text-[11px] font-semibold transition-all ${active ? "border-[hsl(var(--primary))] bg-[hsl(var(--primary))]/15" : "border-[hsl(var(--border))] hover:border-[hsl(var(--primary))]/50"}`}>
            <span className="mr-0.5">{emo}</span>{name}
          </button>
        );
      })}
    </div>
  </div>
);
